export default "__VITE_ASSET__BgAVNH_C__"